import { state } from 'cerebral/tags'
import { toggle, set } from 'cerebral/operators'
import hideFileContextMenu from 'modules/Media/chains/hideFileContextMenu'

export default [
  ...hideFileContextMenu,
  set(state`media.tags.open`, false),
  toggle(state`media.filter.open`)
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onOpenFilterMenu.js